import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import * as Ant from 'antd';
import Breadcrumb from '../../Components/Breadcrumb';

function AboutCommittee(props) {
  const [records, setRecords] = React.useState([]);
  const [selected, setSelected] = React.useState();
  const {id} = qs.parse(props.location.search);

  React.useEffect(() => {
    async function fetchData() {
      AppActions.setLoading(true);
      try {
        const _records = await JStorage.fetchAllDocuments(
          'committee',
          {},
          ['-date'],
          null,
          {
            token: null,
          },
        );
        setRecords(_records);
        setSelected(_records[0]);
      } catch (ex) {
        console.warn('REV_DBG', ex);
      }
      AppActions.setLoading(false);
    }

    fetchData();
  }, [id]);

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>第22屆各委員會施政理念</h2>
        <Breadcrumb third="第22屆各委員會施政理念" />
      </div>

      <Ant.Radio.Group
        buttonStyle="solid"
        onChange={(e) => {
          const value = e.target.value;
          let selected = records.find((x) => x.id === value);
          setSelected(selected);
        }}
        style={{marginBottom: 20}}>
        {records.map((x) => (
          <Ant.Radio.Button key={x.id} value={x.id}>
            {x.name}
          </Ant.Radio.Button>
        ))}
      </Ant.Radio.Group>

      {selected && (
        <React.Fragment>
          <div className="content">
            <div style={{flex: 1}}>
              <h3>{selected.name}</h3>
              <div className="row">
                <label>{selected.director?.name}</label>
                {selected.director?.username}
              </div>
              {(selected.positions || []).map((x) => (
                <div key={x.name} className="row">
                  <label>{x.name}</label>
                  {(x.usernames || []).join('、')}
                </div>
              ))}
            </div>
            <div style={{textAlign: 'center'}}>
              <img
                src={selected.director?.avatar}
                className="avatar"
                alt="user-avatar"
              />
              <div className="avatar-name">
                {selected.director?.name}{' '}
                <span style={{fontSize: 18}}>
                  {selected.director?.username}
                </span>
              </div>
            </div>
          </div>

          <div
            dangerouslySetInnerHTML={{
              __html: selected.raw_html?.enabled
                ? selected.raw_html.html
                : selected.richtext.html,
            }}
          />
        </React.Fragment>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & .ant-radio-group .ant-radio-button-wrapper:nth-child(2n) {
    background: #f5f5f5;
  }

  & .ant-radio-group .ant-radio-button-wrapper:hover,
  .ant-radio-group
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: var(--primaryColor);
    color: #fff;
    border-color: var(--primaryColor);
  }

  & .content {
    display: flex;
    background-color: var(--primaryLightColor);
    padding: 20px;
    gap: 20px;
    margin-bottom: 20px;
    align-items: center;
    & h3 {
      color: var(--primaryColor);
      font-size: 20px;
      margin-bottom: 10px;
    }

    & .row {
      padding-bottom: 5px;
      margin-bottom: 5px;
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);
    }
    & label {
      display: inline-flex;
      color: var(--primaryColor);
      width: 100px;
    }
  }

  & .avatar {
    width: 120px;
    height: auto;
    margin-bottom: 10px;
  }
  & .avatar-name {
    background-color: var(--primaryColor);
    color: white;
    padding: 4px 6px;
  }
`;

export default withPageEntry(AboutCommittee);
